export default __webpack_public_path__ + "static/media/fallback.b5d9c301.jpeg";